// extracted by mini-css-extract-plugin
export default {"arrow":"_2fhqm04s","inverted":"_3LDrfwn9","small":"_3QRvHnro","top":"_1UHNlqcC","bottom":"_2pFXT7cS","left":"_12MakRw9","right":"_2B3lpUPL"};